import { defaults, allowed } from '../../../../lib/genericReducer';

export default function reducer(
  state = {
    fetching: false,
    fetched: false,
    responseMessage: null,
    property_usages: {},
  },
  action
) {
  const types = ['PROPERTY_USAGE'];
  if (!allowed(types, action)) return state;

  state = {
    ...state,
    ...defaults(action),
  };

  switch (action.type) {
    case 'FETCH_PROPERTY_USAGES_FULFILLED': {
      return {
        ...state,
        property_usages: action.payload,
      };
    }
    default:
      break;
  }

  return state;
}
